
import { Axios } from "../api/axios";
import { logger } from "../utils/logger";
export const getMenus = async (userInfo: { isAyce: any; }, storeId: number, tableId: number) => {
	try {
		if(userInfo.isAyce) {
				const response = await Axios(
					{ 
						method: 'GET',
						url: `/v1/menus/ayce/tables/${tableId}`
			
					})
				return response;
			} else {
				const response = await Axios(
					{ 
						method: 'GET',
						url: `/v1/menus/stores/${storeId}`
			
					})
				return response;
			}
	} catch (error) {
		logger.error('Error fetching menus:', error);
	}
}

export const getCategories = async (menuId: number|string) => {
	const parsedMenuId = parseInt(menuId as string, 10);

  if (isNaN(parsedMenuId)) {
    logger.error('Invalid menuId provided:', menuId);
    return null; // 혹은 throw new Error('Invalid menuId')
  }
	try {
		const response = await Axios(
			{ 
				method: 'GET',
				url: `/v1/menus/categories/menus/${parsedMenuId}`
	
			})
		return response;
	} catch (error) {
		logger.error('Error fetching menus:', error);
	}
}

export const getItems = async (categoryId: number) => {
	try {
		const response = await Axios(
			{ 
				method: 'GET',
				url: `/v2/menus/items/categories/${categoryId}`
	
			})
		return response;
	} catch (error) {
		logger.error('Error fetching menus:', error);
	}
}

export const getItemDetail = async (itemId:number, categoryId: number, tableId: number) => {
	try {
		let response = null
		if(categoryId) {
			response = await Axios(
				{ 
					method: 'GET',
					url: `v2/menus/items/${itemId}/categories/${categoryId}/tables/${tableId}`
		
				})

		} else {
			response = await Axios(
				{ 
					method: 'GET',
					url: `v2/menus/items/${itemId}`
		
				})
		}
		return response
	} catch (error) {
		logger.error('Error fetching menus:', error);
	}
}

export const getAllMenuImage = async (storeId: number) => {
	try {
		const response = await Axios(
			{ 
				method: 'GET',
				url: `/v1/menus/item-images/stores/${storeId}`
	
			})
		return response;
	} catch (error) {
		logger.error('Error fetching menus:', error);
	}
}
